<template>
	<div class="sale-shop">
		<!-- 导航 -->
		<!-- <van-nav-bar
		  title="店铺管理"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<headerTemplate title="店铺管理"></headerTemplate>

		<!-- div -->
		<div class="shop-manage">
			<div class="shop-wrapper">
				<span>用户名：</span>
				<span class="shop-content">{{StoreList.member_name}}</span>
			</div>
			<div class="shop-wrapper">
				<span>店铺名：</span>
				<span class="shop-content">{{StoreList.store_name}}</span>
			</div>
			<div class="shop-wrapper">
				<span>店铺地址：</span>
				<span class="shop-content">{{StoreList.store_url}}</span>
			</div>
			<div class="shop-wrapper">
				<span>分销合作添加时间：</span>
				<span class="shop-content">{{StoreList.store_addtime}}</span>
			</div>
			<div class="shop-wrapper">
				<span>分销合作结束时间：</span>
				<span class="shop-content">{{StoreList.store_endtime}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { getStore } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleShop',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 店铺管理列表
				StoreList: []
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			}
		},
		created() {
			getStore().then(res => {
				this.StoreList = res.result
			}).catch(error => {
				// this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.sale-shop {
		font-size: 14px;

		.shop-manage {
			margin: 10px;
			box-shadow: 0 0 5px #949191;
			padding: 10px;

			.shop-wrapper {
				margin-bottom: 10px;
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #dcdada;
				padding-bottom: 10px;

				.shop-content {
					font-weight: bold;
				}
			}
		}
	}

	/* .sale-shop   ::v-deep.van-nav-bar {
	background-color: #e93b3d;
	color: white;
	.van-icon-arrow-left, .van-nav-bar__text, .van-nav-bar__title {
		color: white;
	}
} */
</style>